import { createBrowserRouter } from 'react-router';
import UnexpectedErrorPage from './component/unexpected-error-page.tsx';
import NotFoundPage from './component/not-found-page.tsx';
import ticketAnsichtRoutes from '../domain/ticket-ansicht/ticket-ansicht-routes.tsx';
import checkoutRoutes from '../domain/bezahlen/checkout-routes.tsx';
import ticketScannenRoutes from '../domain/ticket-scan/ticket-scannen-routes.tsx';
import ticketErsetzenRoutes from '../domain/ticket-ersatz/ticket-ersetzen-routes.tsx';
import paymentErrorRoutes from '../domain/payment-error/payment-error-routes.tsx';
import versionshinweiseRoutes from '../domain/lizenzhinweise/lizenzhinweise-routes.tsx';
import kontaktRoutes from '../domain/kontakt/kontakt-routes.tsx';
import agbRoutes from '../domain/agb/agb-routes.tsx';

/**
 * Creates and returns a router instance configured with application routes.
 *
 * The router includes lazy-loaded routes for the application, a custom error page,
 * and a fallback route for handling 404 Not Found cases.
 */
export default function createRouter() {
  return createBrowserRouter([
    {
      lazy: () => import('../app.tsx'),
      errorElement: <UnexpectedErrorPage />,
      children: [
        {
          path: '/',
          lazy: () => import('../domain/landing/page/landing-page.tsx'),
        },
        ...ticketErsetzenRoutes,
        ...ticketScannenRoutes,
        ...ticketAnsichtRoutes,
        ...checkoutRoutes,
        ...paymentErrorRoutes,
        ...versionshinweiseRoutes,
        ...kontaktRoutes,
        ...agbRoutes,
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
  ]);
}
